export default __webpack_public_path__ + "static/media/logoWhite.85141226.svg";